import './index.css';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import '@formatjs/intl-numberformat/polyfill';
import '@formatjs/intl-numberformat/locale-data/de.js';
import '@formatjs/intl-numberformat/locale-data/en.js';

import '~/common/i18n';
import '~/services/http';
import { appConfig } from '~/common/config';
import { App } from '~/components/App/App';
import { ErrorFallback } from '~/components/ErrorFallback/ErrorFallback';

const container = document.getElementById('root');

if (appConfig.sentry.enabled) {
  Sentry.init({
    dsn: appConfig.sentry.dsn,
    release: appConfig.version,
    environment: appConfig.sentry.environment,
  });
}

if (container) {
  const root = createRoot(container);
  root.render(
    <Sentry.ErrorBoundary fallback={ErrorFallback}>
      <App />
    </Sentry.ErrorBoundary>,
  );
}
